// Models
import { createQaStoreDefaultModel } from './qa/qa.store'

const qaModels = {
  qa: createQaStoreDefaultModel(),
}

export { qaModels }
